import {types} from "mobx-state-tree";


export const Brand = types.model('Brand', {
    uuid: types.identifier,
    label: types.optional(types.string, ""),
})

export const BrandStore = types.model('BrandStore', {
    isLoading: types.optional(types.boolean, false),
    list: types.optional(types.array(Brand), []),
}).actions((self) => ({
    setBrandList(brandList) {
        const list = !brandList? "": brandList?.map((brand) => Brand.create({
            uuid: brand?.id.toString(),
            label: brand?.attributes.name,
        })).sort((a, b) => a.label.localeCompare(b.label)) //sort alphabetically by label
        self.list = [{uuid: "all", label: "All"}, ...list]
    },
}))
